<section class="balance-charges-coc-summary" data-balance-charges-coc-summary>
  <h4 class="balance-charges-coc-summary__title">{{ 'balance.charges.coc-summary-title' | translate }}</h4>
  <ul class="balance-charges-coc-summary__list">
    <li
      *ngFor="let row of rows; trackBy: trackByVisitNumber"
      class="balance-charges-coc-summary__row"
      [class.balance-charges-coc-summary__row--empty]="row.empty"
      [matTooltip]="row.empty ? ('balance.charges.coc-summary-empty-visit-tooltip' | translate) : ''"
      data-coc-summary-row
      [attr.data-visit-number]="row.visitNumber"
      [attr.data-appointment-id]="row.appointment?.id">
      <span class="balance-charges-coc-summary__label">{{ 'balance.visit' | translate }} {{ row.visitNumber }}</span>
      <ng-container *ngIf="!unscheduledMode">
        <span class="balance-charges-coc-summary__date">{{ row.dateLabel }}</span>
        <span class="balance-charges-coc-summary__appointment-cpts" data-appointment-cpts>
          ({{ row.appointmentCpts.length ? row.appointmentCpts.join(', ') : EMPTY_PLACEHOLDER }})
        </span>
      </ng-container>
      <span class="balance-charges-coc-summary__estimator-cpts" data-estimator-cpts>
        {{ row.estimatorCpts.length ? row.estimatorCpts.join(', ') : EMPTY_PLACEHOLDER }}
      </span>
    </li>
  </ul>
</section>
